var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-grid"},_vm._l((_vm.data),function(event){return _c('Event',{key:event.id,attrs:{"event":event}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }